
import type { $Fetch } from "ofetch";

/**
 * Nome do Controller da API
 */
const controller = "/ativarCertificado";

/**
 * Classe de gerenciamento de chamadas da API dos módulos
 *
 * @class
 */
export default class AtivarCertificadoApi {
    /**
     * Instância da dependência da API (ofetch)
     */
    private api;

    /**
     * Cria uma nova instância da classe AtivarCertificadoApi.
     * @constructor
     * @param api - Instância da dependência da API (ofetch).
     */
    constructor(api: $Fetch) {
        this.api = api;
    }


    /**
     * Ativa um certificado para um cpf/cnpj
     * @param ativarCertificadoRequest - Objeto com cpf/cnpj e pin
     * @returns Uma mensagem 
     */
    ativarCertificado(ativarCertificadoRequest: AtivarCertificadoRequest) {
        return this.api<ApplicationModule[]>(`${controller}/ativar-certificado`, {
            method: "POST",
            body: ativarCertificadoRequest,
        });
    }
}
